enum Roles {
  ADMINISTRADOR = "ADMINISTRADOR",
  USUARIO = "USUARIO",
}

export { Roles };
